export const VERACITIES = [
  {
    name: "Official Source",
    display: true,
  },
  {
    name: "Government Source",
    display: true,
  },
  {
    name: "High Quality",
    display: true,
  },
  {
    name: "Unknown Quality",
    display: false,
  },
  {
    name: "Low Quality",
    display: true,
  },
  {
    name: "Misinformation",
    display: true,
  },
  {
    name: "State Run News",
    display: true,
  },
  {
    name: "Unverified",
    display: false,
  },
  {
    name: "Verified",
    display: false,
  },
];
